/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PushNotificationCategorySource } from './PushNotificationCategorySource';
import {
    PushNotificationCategorySourceFromJSON,
    PushNotificationCategorySourceFromJSONTyped,
    PushNotificationCategorySourceToJSON,
} from './PushNotificationCategorySource';

/**
 * 
 * @export
 * @interface PushNotificationCategoryAdminResponse
 */
export interface PushNotificationCategoryAdminResponse {
    /**
     * 
     * @type {PushNotificationCategorySource}
     * @memberof PushNotificationCategoryAdminResponse
     */
    source: PushNotificationCategorySource;
    /**
     * 
     * @type {boolean}
     * @memberof PushNotificationCategoryAdminResponse
     */
    defaultEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationCategoryAdminResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationCategoryAdminResponse
     */
    key: string;
}



/**
 * Check if a given object implements the PushNotificationCategoryAdminResponse interface.
 */
export function instanceOfPushNotificationCategoryAdminResponse(value: object): value is PushNotificationCategoryAdminResponse {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('defaultEnabled' in value) || value['defaultEnabled'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function PushNotificationCategoryAdminResponseFromJSON(json: any): PushNotificationCategoryAdminResponse {
    return PushNotificationCategoryAdminResponseFromJSONTyped(json, false);
}

export function PushNotificationCategoryAdminResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushNotificationCategoryAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'source': PushNotificationCategorySourceFromJSON(json['source']),
        'defaultEnabled': json['defaultEnabled'],
        'displayName': json['displayName'],
        'key': json['key'],
    };
}

export function PushNotificationCategoryAdminResponseToJSON(value?: PushNotificationCategoryAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'source': PushNotificationCategorySourceToJSON(value['source']),
        'defaultEnabled': value['defaultEnabled'],
        'displayName': value['displayName'],
        'key': value['key'],
    };
}

